<template>
  <a href="#">
    <img
      width="36" height="36"
      :src="
        `https://cdnx.softsq.com/thumb/unsafe/36x36/${encodeURIComponent(
          encodeURIComponent(profile.imageProfile || 'https://a.tourprox.com/logoprofile/112/logo.jpg'),
        )}`
      "
      class="uk-border-circle"
      style="width: 36px; height: 36px;"
      data-src="holder.js/36x36"
      data-holder-rendered="true"
    />
  </a>
</template>
<script>
export default {
  name: 'ReservationSmall',
  props: ['profile'],
  data() {
    return {};
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/ReservationSmall.vue